import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  
  const [topicName, setTopicName] = React.useState("");

  ///const [topicName, setTopicName] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
      setTopicName("");

  }, [props.dataObj,open]);

	function saveData(){    
    
    if(!topicName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter keyword name");			
      return false;
    }  

    
		if(topicName && topicName.length>0){ 
      setSaveLoading(true);

			let axiosHeader = {
				headers: {
          'Content-Type': 'multipart/mixed',
            'device': 'web',
            'uid': userObj.loginId,
            'fullName': userObj.fullName,
            'token': userObj.token,
        }
			}; 
      ///alert('asdf '+JSON.stringify(props.dataObj));
			const data = new FormData();
      data.append('parentId', props.dataObj.autoId);
      data.append('keywordName', topicName);

      let apiURL='/add-multiple-keywords-treeview';
      let myMessage="Keyword has been added.";
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");          
					setAlertMessage(myMessage);

          props.reloadList();

          // if(response.data.obj.list && response.data.obj.list.length>0){
          //   ///document.write(JSON.stringify(response.data.obj.list));
          //   //props.tempTreeview(response.data.obj.list);
            	
          // }
          setOpen(false);
					setShowAlert(true);         
					return false;

        }else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("It could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}
  
  function handleTopicName(str){
    str = Array.from(new Set(str.split("\n"))).join("\n");
    ///str = str.replace(/[()]/g, '');
    str = str.replace(/\(.*?\)/g, '');
    //str = str.replace(/\[.*?\]/g, ''); 
    str = str.replace(/(^[ \t]*\n)/gm, "");
    setTopicName(str);
  }


  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>Selected: {props.dataObj.title} </h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{textAlign:'center'}} >
                            Keyword Names (One Keyword in One Line)
                                <TextField multiline rows={15} onChange={event => handleTopicName(event.target.value)} value={topicName} placeholder={'Keyword Name'} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {saveLoading?
                          <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Saving</LoadingButton>
					    	          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;